const scriptTag = document.querySelector('script[data-key][data-api]');
const CONTENT_API_KEY = scriptTag.getAttribute('data-key');
const CONTENT_API_URL = scriptTag.getAttribute('data-api');
const GHOST_BASE_URL = scriptTag.getAttribute('data-ghost');

const BASE_URL = `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
const MEMBER_URL = "/members/api/member/";

// console.log('CONTENT_API_KEY:', CONTENT_API_KEY);
// console.log('CONTENT_API_URL:', CONTENT_API_URL);
// console.log('GHOST_BASE_URL:', GHOST_BASE_URL);

export async function fetch_api(url_path, params = ''){   
    //await new Promise(resolve => setTimeout(resolve, 5000));//Pause loading for 5 seconds
    try {
        const res = await fetch(`${CONTENT_API_URL}${url_path}/?key=${CONTENT_API_KEY}${params}`);
        
        if (!res.ok) {
            // If the response status is not OK (not in the range 200-299), throw an error
            throw new Error(`Fetch API error status code: ${res.status}`);
        }
        
        const result = await res.json();
        console.log('[*] Fetch result -> ', result);
        return result;
        
    } catch (error) {
        // Handle any errors that occur during the fetch or processing
        console.error('[X] Fetch error:', error);
        return { error: error.message }; // Return error details
    }    
}

export async function get_member_data(){
    try {
        const res = await fetch(`${GHOST_BASE_URL}members/api/member`);
        
        if (!res.ok) {
            // If the response status is not OK (not in the range 200-299), throw an error
            throw new Error(`Fetch Members data error status code: ${res.status}`);
        }
        if(res.status === 200){
            const result = await res.json();
            //console.log('[*] Get member data -> ', result);
            return result;
        }
        
    } catch (error) {
        // Handle any errors that occur during the fetch or processing
        console.error(`[X] Get Member data error: ${error.message}`);
        throw new Error(`Get Member data error: ${error.message}`);
    } 
}

export async function member_logout(){
    try {
        const res = await fetch(`${GHOST_BASE_URL}members/api/session`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            }
        });
        
        if (!res.ok) {
            // If the response status is not OK (not in the range 200-299), throw an error
            throw new Error(`Fetch Members data error status code: ${res.status}`);
        }
        
    } catch (error) {
        // Handle any errors that occur during the fetch or processing
        console.error(`[X] Logout member error: ${error.message}`);
        throw new Error(`Logout member error: ${error.message}`);
    } 
}

export async function getNewsletters(){
    try{
        let res = await fetch(`${CONTENT_API_URL}newsletters/?key=${CONTENT_API_KEY}&limit=all`);
        if(res.status != 200) throw new Error(`Newsletter API failed with status code: ${res.status}`);
        let result = await res.json();
        return result.newsletters

    }catch(err){
        console.log('[x] Error in newsletter data fetch...', err.message);
        throw new Error(err.message);
    }
}

export async function updateNewsletter(payload){
    try{
        let res = await fetch(BASE_URL + MEMBER_URL, {
            method:'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(payload)
        })
        if(res.status != 200) throw new Error(`Member api update failed, status ${res.status}`);
        let result = await res.json();
        console.log('[+] Update member data ', result);
    }catch(err){
        console.log('[x] error in member api ', err.message);
        throw new Error(`Error in member api ${err.message}`);
    }

}



export async function check_server_online(helper_url){
    try {
        const res = await fetch(`${helper_url}is-online-check`, { method:'POST' });
        
        if (!res.ok) {
            // If the response status is not OK (not in the range 200-299), throw an error
            throw new Error(`error status code: ${res.status}`);
        }        
        const result = await res.json();
        return result;
        
    } catch (error) {
        // Handle any errors that occur during the fetch or processing
        console.error(`[X] Server Health Check failed: ${error.message}`);
        throw new Error(`Server Health Check failed: ${error.message}`);
    } 
}


/**
 * Initiates the Stripe checkout process for a customer.
 * Server check intention and if user already has running subscription, in such case it returns error.
 * @param {string} helper_url - server base url
 * @param {string} intention - action intention
 * @param {Object} get_tier_details - tier info
 * @param {Object} client_details - user info
 */
export async function stripe_checkout_session(helper_url, intention, get_tier_details, client_details){
    try{

        const res = await fetch(helper_url + 'stripe', {
            method:'POST',
            headers:{
                'Content-Type': 'application/json',
                'X-KEY':'UJUt9eRXYStxSZFCDUZ6am5sFx9pPAFPZm'
            },
            body: JSON.stringify({
                'tier_name': get_tier_details.name,
                'price': get_tier_details.price,
                'interval': get_tier_details.interval,
                'member_status': client_details.member_status,
                'client_email': client_details.client_email,
                'client_stripe_id': client_details.client_stripe_id,
                'client_stripe_sub_id': client_details.client_stripe_sub_id,
                'client_intention': intention,
                'comped': client_details.comped
            })
        });

        if(res.status != 200) throw new Error(`Subscribe error - status code: ${res.status}`);

        const result = await res.json();
        return result;

    }catch(err){
        console.log('[+] Error in checkout process', err.message);
        return {'message':'error', 'data':err.message};
    }
}


